import {cleanPropsName} from "@commons/utils/util";
import {Views} from "@commons/Views";

export type SchemaTypes = 'flat' | 'DataTables' | 'export2excel';

export interface BaseQueryParams {
    start: number,
    length: number,
    mode: SchemaTypes,
    view: Views,
    search?: {
        value?: string,
        regex?: boolean
    },
    token?: string,
}

export const addQueryParams = (params: string[]) => params.length > 0 ? encodeURI(params.join("&")) : '';

export const addBaseQueryParams = (filter: Partial<BaseQueryParams>, params: string[] = []) => {
    if (filter.mode)
        params.push(`mode=${filter.mode}`);
    if (filter.view)
        params.push(`view=${filter.view}`);
    if (filter.start)
        params.push(`start=${filter.start}`);
    if (filter.length)
        params.push(`length=${filter.length}`);

    if (filter.token) // new 20/09/2024, necessario nel caso di chiamate da NestJS
        params.push(`auth_token=${filter.token}`);

    if (filter.search && filter.search.value && filter.search.value.length > 0) {
        params.push('search[value]=' + filter.search.value);
        params.push('search[regex]=' + filter.search.regex);
    }
    return params;
}

export interface AziendaFilterSelection extends BaseQueryParams {
    codAzienda: number | null;
    codFiliale: string | null;
    denominazione: string | null;
    unitaLocale: string | null;
}

export interface IdAziendaParams extends BaseQueryParams {
    idAzienda: number | null;
}

export interface ULParams extends BaseQueryParams {
    idAzienda: number | null;
    codAzienda: number | null;
}

const transformResponse0 = (response: any, meta: any, arg: any) => {
    let newResponse: any = {};
    if (response) {
        newResponse = cleanPropsName(response, false);
    }
    return newResponse;
};

export const transformResponse = (response: any, meta: any, arg: any) => {
    const isArray = (arr: any) => Array.isArray(arr);
    if (response) {
        if (isArray(response)) {
            let newResponse: any[] = [];
            for (let elem of response) {
                newResponse.push(cleanPropsName(elem, false))
            }
            return newResponse;
        } else
            return cleanPropsName(response, false);
    } else return {} as any;
};

//export function addURI<T extends BaseQueryFn>(baseQueryReturnValue: BaseQueryResult<T>, meta: BaseQueryMeta<T>, arg: any) {
export function addURI(baseQueryReturnValue: any, meta: any, arg: any) {
    let newResponse = transformResponse(baseQueryReturnValue, meta, arg);
    if (newResponse && !newResponse.URI)
        if (meta && meta.request) {
            const index = meta.request.url.indexOf('?');
            if (index >= 0)
                newResponse.URI = meta.request.url.substring(0, index);
            else
                newResponse.URI = meta.request.url;
        }
    return newResponse;
}